import app from 'flarum/forum/app';
import registerWidget from '../common/registerWidget';

app.initializers.add('zr/zr01-html-widget', () => {
    registerWidget(app);
});
